import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IBreadcrumb } from 'projects/access-control/src/app/Domain/Entities/breabcumd.interface';
import { DataTranslatePages } from 'projects/access-control/src/app/Domain/Entities/data-translate-pages';
import { Groups } from 'projects/access-control/src/app/Domain/Entities/group.interface';
import { Tabs } from 'projects/access-control/src/app/Domain/Entities/tabs.interface';
import {
	deleteGroup,
	getDetailGroups,
	getGroup,
	getSubGroups,
	getUsersGroups,
} from 'projects/access-control/src/app/Infrastructure/Store/groups/groups.action';
import { selectGroupState } from 'projects/access-control/src/app/Infrastructure/Store/groups/groups.selectors';
import { ModalNewGroupComponent } from 'projects/access-control/src/app/UI/components/modal-new-group/modal-new-group.component';
import { TranslateService } from '@mangosoft/mango-layout';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

interface DataTranslateGroups extends DataTranslatePages {
	textSubGroups: string;
	textUsers: string;
	delete: string;
	buttonDelete: string;
	buttonEdit: string;
	notSelectesGroup: string;
	notSubGroups: string;
	textHoverGroups: string;
	textHoverSubGroups: string;
}
@Component({
	selector: 'app-groups',
	templateUrl: './groups.component.html',
	styleUrls: ['./groups.component.scss'],
})
export class GroupsComponent implements OnInit, OnDestroy {
	tabs: Tabs[] = [];
	breadcrumb: IBreadcrumb[] = [];
	groups: Groups[] = [];
	viewSelect: string = '';
	elementsDelete: string = '';
	loading = false;
	loadingGeneral = false;
	translateGroups: DataTranslateGroups = {} as DataTranslateGroups;
	subscriptionGroups!: Subscription;
	subscriptionTranslate!: Subscription;
	isSubGroup = false;
	groupSelected: Groups = {} as Groups;
	isGroupsSelect = false;
	public searchClient: string;
	levelGroup: Groups[] = [];
	disabledRefresh = true;
	openAlert: boolean = false;
	valueModalDelete = '';
	groupDeleteSelected: Groups = {} as Groups;
	isLoading = false;
	rows: Groups[] = [];
	userTable: Groups[] = [];
	viewGroups: boolean = true;

	constructor(
		private store: Store,
		public dialog: MatDialog,
		private translateService: TranslateService
	) {
		this.searchClient = '';
	}

	ngOnInit(): void {
		this.store.dispatch(getGroup());
		this.getGroups();
		this.getTranslate();
	}
	getTranslate() {
		this.translateService.init('AccessControl').subscribe((data) => {
			this.translateGroups = data.pages.groups;
			this.tabs = data.pages.groups.tabs.titles;
			this.orderGroups();
		});
	}

	getGroups() {
		this.subscriptionGroups = this.store
			.pipe(select(selectGroupState))
			.subscribe(({ groups, groupSelected, loading, loadingGeneral, viewGroups }) => {
				const groupsData = groups as Groups[];
				this.groups = groupsData.filter((item) => item.sk !== '01GD47Q3JT8Y0WPTG37QGBERX0:current').map((group) => {
					return {
						...group,
						picture: group?.picture ? group?.picture.replace('s3.amazonaws.com/', '') : '',
					};
				}) as Groups[];
				this.groupSelected = {
					...groupSelected,
					picture: groupSelected?.picture ? groupSelected.picture.replace('s3.amazonaws.com/', '') : '',
				} as Groups;
				this.viewGroups = viewGroups;
				//Si No hay un grupo seleccionado pero el breadcrumb tiene mas de un elemento devuelvo todo a la primera posicion
				if (this.breadcrumb.length > 1 && !groupSelected?.sk) {
					this.breadcrumb.pop();
					this.levelGroup.pop();
				}
				if (this.isGroupsSelect) {
					//Si se selecciono un grupo extraigo los subgrupos de ese Grupo.
					this.store.dispatch(
						getSubGroups({
							pk: this.groupSelected.pk,
							sk: this.groupSelected.sk,
						})
					);
					// if (this.groupSelected.subGroups > 0)
					this.isGroupsSelect = false;
				}
				this.orderGroups();
				this.loading = loading;
				this.loadingGeneral = loadingGeneral;
			});
	}

	searchSidebar(search: any) {
		this.searchClient = search;
	}

	openDialogGroups(typeValue = '', groupValue: Groups = {} as Groups) {
		const type: string = this.groupSelected.sk ? 'newSubGroups' : 'newGroups';
		const group: Groups = this.groupSelected.sk ? this.groupSelected : ({} as Groups);
		const dialogRef = this.dialog.open(ModalNewGroupComponent, {
			height: '450px',
			width: '687px',
			data: {
				type: typeValue === 'updateGroup' || typeValue === 'updateSubGroup' ? typeValue : type,
				group: groupValue.sk ? groupValue : group,
			},
		});
	}
	tabSelect(event: any) {
		this.viewSelect = event;
	}

	selectGroupView(group: Groups) {
		if (!this.levelGroup.find((idGroup) => idGroup.pk === group.pk && idGroup.sk === group.sk)) {
			if (this.levelGroup.length > 0) {
				const groupLevel = this.levelGroup[this.levelGroup.length - 1];
				if (
					this.groups.find((idGroup) => idGroup.sk === groupLevel.sk) &&
					groupLevel.subGroups === 0
				) {
					this.levelGroup.pop();
					this.breadcrumb.pop();
				} else {
				}
			}
			this.viewSelect = '1';
			this.levelGroup.push(group);
			this.groupSelected = group;
			this.breadcrumb.push({ text: group.name, id: [group.sk] });
			this.store.dispatch(getDetailGroups({ url: group.infoGroupUrl }));
			this.isGroupsSelect = true;
			this.isSubGroup = true;
		}
	}

	btnBack(event: boolean) {
		if (this.levelGroup.length === 1) {
			this.groups = [];
			this.store.dispatch(getGroup());
			this.isSubGroup = false;
			this.groupSelected = {} as Groups;
		} else {
			this.viewSelect = '1';
			this.groupSelected = this.levelGroup[this.levelGroup.length - 2]; //selecciono
			this.store.dispatch(getDetailGroups({ url: this.groupSelected.infoGroupUrl }));
			this.isGroupsSelect = true;
			this.isSubGroup = true;
		}
		this.levelGroup.pop();
		this.breadcrumb.pop();
	}

	positionBreadcrumb(breadcrumb: IBreadcrumb) {
		if (breadcrumb.id[0] === 'groupPrincipal') {
			this.store.dispatch(getGroup());
			this.levelGroup = [];
			this.breadcrumb = [];
			this.groupSelected = {} as Groups;
			this.isSubGroup = false;
			//Extraer grupos padres
		} else {
			//Hijo de un grupo
			const sk = breadcrumb.id[0];
			const indexGroups = this.levelGroup.map((group) => group.sk).indexOf(sk);
			this.levelGroup = this.levelGroup.slice(0, indexGroups + 1);
			this.breadcrumb = this.levelGroup.map((level) => {
				return {
					text: level.name,
					id: [level.sk],
				};
			});
			this.viewSelect = '1';
			this.groupSelected = this.levelGroup[this.levelGroup.length - 1]; //selecciono
			this.store.dispatch(getDetailGroups({ url: this.groupSelected.infoGroupUrl }));
			this.isGroupsSelect = true;
			this.isSubGroup = true;
		}
	}

	closeModalAlert(resp: any) {
		if (resp.value === 'deleteGroups' && resp.resp) {
			this.store.dispatch(
				deleteGroup({ ids: { sk: this.groupDeleteSelected.sk, pk: this.groupDeleteSelected.pk } })
			);
		}
		this.groupDeleteSelected = {} as Groups;
		this.openAlert = false;
	}

	orderGroups() {
		this.groups = this.groups.map((group) => {
			//Se agregan los items para las opciones de modificar y eliminar en el popup
			return {
				...group,
				items: [
					{
						label: this.translateGroups.buttonEdit,
						icon: 'pi pi-pencil',
						command: () => {
							this.openDialogGroups(
								this.groupSelected.sk ? 'updateSubGroup' : 'updateGroup',
								group
							);
						},
					},
					{
						label: this.translateGroups.buttonDelete,
						icon: 'pi pi-trash',
						command: () => {
							this.groupDeleteSelected = group;
							this.elementsDelete = `${this.translateGroups.delete} '${group.name}'`;
							this.openAlert = true;
							this.valueModalDelete = 'deleteGroups';
						},
					},
				],
			};
		});
	}
	ngOnDestroy(): void {
		this.subscriptionTranslate?.unsubscribe();
		this.subscriptionGroups?.unsubscribe();
	}
}
